<template>
  <div class="Blockbox_right">
    <div class="blocktit">Daily Contract Call Distribution</div>
    <div class="blockboxlist">
      <div class="blockboxleft">
        <div class="blocktitl">
          <ul>
            <el-date-picker v-model="value1" type="date" placeholder="">> </el-date-picker>
          </ul>
          <div class="blocktitr">
            <span>Jul 30,2015</span>
            <span>-></span>
            <span>Apr 18,2023</span>
          </div>
        </div>
        <div id="charts" ref="chart" style="width: 636px; height: 390px"></div>
      </div>
      <div class="blockboxright">
        <div class="boxright">
          <div class="blockrtit">About</div>
          <div class="blockrcton">
            The most frequently used contract list on TFSC, sorted by the number
            of calls.
          </div>
        </div>
        <div class="boxright">
          <div class="blockrtit">Highlights</div>
          <div class="blockrcton">
            The contract XXX had the highest number of calls yesterday,with 255
            calls,accounting for 85.2% of the total.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Homseach from "@/components/pc/serch.vue";
import leftcompo from "./../left.vue";
const echarts = require("echarts");
export default {
  data() {
    return {
      ind: 0,
      name: "",
      value1: "",
      value2: "",
    };
  },
  computed: {
    getClientTimezone() {
      var oDate = new Date();
      var nTimezone = -oDate.getTimezoneOffset() / 60;
      return nTimezone.toFixed(2);
    },
  },
  watch: {
    // deep: true,
    $route: {
      handler: function (to) {
        console.log(to.query);
      },
      deep: true,
      immediate: true,
    },
  },
  components: {
    Homseach,
    leftcompo,
  },
  mounted() {
    this.initCharts1();
    this.value1=new Date();
  },
  methods: {
    initCharts1() {
      this.lineChart = echarts.init(this.$refs.chart);
      var datas = [
        { value: 1048, name: "USDT Token" },
        { value: 735, name: "LF8iBW9y1KL...pMszf" },
        { value: 580, name: "FTH-DC Token" },
        { value: 484, name: "DCT Token" },
        { value: 300, name: "LFdko4yMVrK...9D7iA" },
        { value: 300, name: "S-USDT-TRX Token" },
        { value: 100, name: "USDT Tokenaa" },
      ];

      var option;

      option = {
        tooltip: {
          trigger: "item",
        },

        legend: {
          show: true,
          orient: "vertical",
          x: "45%", //可设定图例在左、右、居中
          y: "center",
          icon: "circle",
          padding: [0, 50, 0, 0],
          itemHeight: 9, // 图例icon高度
          itemWidth: 9, // 图例icon宽度
          align: "left", // 图例icon在左侧
          itemGap: 30, // 图例每项之间的间隔。
          itemHeight: 14, //  图例标记的图形高度。
          formatter: function (name) {
            // 添加
            let total = 0;
            let target;
            for (let i = 0; i < datas.length; i++) {
              total += datas[i].value;
              if (datas[i].name === name) {
                target = datas[i].value;
              }
            }
            var arr = [
              "{a|" + name + "}",

              "{c|" + target + " " + "calls" + "}",
              "{b|" + ((target / total) * 100).toFixed(2) + "%}",
            ];
            return arr.join("  ");
          },
          textStyle: {
            // 添加
            padding: [0, 0, 0, 0],
            rich: {
              a: {
                fontSize: 15,
                // width: 10,
                color: "#fff",
              },
              b: {
                fontSize: 15,
                width: 80,
                color: "#c1c1c1",
              },
              c: {
                fontSize: 15,
                color: "#fff",
                width: 80,
              },
            },
          },
        },
        graphic: [
          {
            type: "text",
            left: "22%",
            top: "center",
            style: {
              text: "Total\n",
              textAlign: "center", //水平居中
              fill: "#91979D", //字体颜色
              width: 50,
              height: 30,
              font: '20px "STHeiti"', //字体大小
            },
          },
          {
            type: "text",
            left: "18%",
            top: "55%",
            style: {
              // text: '总数',
              text: datas.reduce((n, i) => {
                return (n += i.value);
              }, 0),

              textAlign: "center",
              fill: "#fff",
              width: 30,
              height: 30,
              fontSize: 32,
            },
          },
          {
            type: "text",
            left: "22%",
            top: "65%",
            style: {
              text: "Calls\n",
              textAlign: "center", //水平居中
              fill: "#91979D", //字体颜色
              width: 50,
              height: 30,
              font: '20px "STHeiti"', //字体大小
            },
          },
        ],
       
        color: [
          "#00E79A",
          "#FFC302",
          "#A952FF",
          "#48D3E2",
          "#F76C9C",
          "#7C9FFC",
          "#9E3820",
        ],
        series: [
          {
            // name: "Access From",
            type: "pie",

            radius: ["40%", "60%"],
            center: ["25%", "55%"],
            avoidLabelOverlap: false,
            itemStyle: {
              // borderRadius: 10,
              // borderColor: "#fff",
              borderWidth: 2,
            },
            label: {
              show: false,
              position: "center",
            },
            emphasis: {
              label: {
                show: false,
                fontSize: "40",
                fontWeight: "bold",
              },
            },
            labelLine: {
              show: false,
            },
            data: datas,
          },
        ],
      };

      if (option && typeof option === "object") {
        this.lineChart.setOption(option);
      }

      window.addEventListener("resize", this.lineChart.resize);
    },
  },
};
</script>

<style lang="less">
// .el-input__icon{
//   margin-left: 70px;
// }
.el-icon-circle-close{
// border: 1px solid red;
margin-right: 76px;
}
.el-input__inner {
  background: #2c2e35;
  border: none;
  width: 142px !important;
  font-size: 14px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #898b8d;
}
.el-picker-panel {
  background: #000000 !important;
  color: #ffffff;
  border: none !important;
  line-height: 20px;
}
.el-picker-panel .el-date-range-picker__time-header {
  border-bottom: 1px solid #93bee7 !important;
}
.el-picker-panel__icon-btn {
  width: 8px;
  height: 10px;
  color: #898b8d !important;
}
.el-picker-panel .el-input__inner {
  background-color: #19466f;
  border: #75ebf2;
  color: #e8fdff;
}
.el-date-table td.current:not(.disabled) span {
  background: #fff !important;
  color: #000000 !important;
}
.el-date-picker__header-label {
  color: #898b8d !important;
}
.el-date-picker__header-label:hover {
  color: #ffffff;
}
.el-date-table td.disabled div {
  background-color: #6891cfa8 !important;
}
.el-picker-panel .el-date-table th {
  color: #898b8d;
  border: none !important;
}
.el-picker-panel .el-date-table td.available {
  font-size: 16px;
  font-weight: bold;
  color: #fff;
}
.el-picker-panel .el-date-table td.available:hover {
  color: #ffffff;
}
.Blockbox {
  display: flex;
  margin-top: 20px;

  .Blockbox_right {
    // margin-left: 20px;
    width: 852px;
    height: 571px;
    background: #000000;
    border-radius: 20px 20px 20px 20px;
    opacity: 1;
    .blocktit {
      padding-top: 20px;
      // margin-left: 20px;
      font-size: 18px;
      font-family: Source Han Sans CN-Medium, Source Han Sans CN;
      font-weight: 500;
      color: #ffffff;
    }
    .blockboxlist {
      display: flex;
      margin-top: 20px;
      // border: 1px solid red;
      .blockboxleft {
        width: 634px;
        height: 485px;
        background: #0b0c0f;
        border-radius: 16px 16px 16px 16px;
        opacity: 1;
        // border: 1px solid yellow;
        margin-right: 20px;
        .blocktitl {
          margin-top: 20px;
          margin-left: 20px;
          margin-right: 20px;
          display: flex;
          justify-content: space-between;
          ul {
            display: flex;
            li {
              width: 33px;
              height: 20px;
              background: #1c1e24;
              border-radius: 5px 5px 5px 5px;
              opacity: 1;
              font-size: 14px;
              font-family: Source Han Sans CN-Regular, Source Han Sans CN;
              font-weight: 400;
              color: #898b8d;
              line-height: 20px;
              margin-right: 10px;
              text-align: center;
            }
            .active {
              background: none;
              font-size: 14px;
              font-family: Source Han Sans CN-Medium, Source Han Sans CN;
              font-weight: 500;
              color: #00e79a !important;
            }
          }
        }
        .blocktitr {
          font-size: 14px;
          font-family: Source Han Sans CN-Regular, Source Han Sans CN;
          font-weight: 400;
          color: #898b8d;
        }
      }
      .blockboxright {
        width: 178px;
        height: 485px;
        background: #0b0c0f;
        border-radius: 16px 16px 16px 16px;
        opacity: 1;
        .boxright {
          margin-top: 20px;
          margin-left: 20px;
          margin-right: 20px;
          .blockrtit {
            font-size: 14px;
            font-family: Source Han Sans CN-Regular, Source Han Sans CN;
            font-weight: 400;
            color: #ffffff;
          }
          .blockrcton {
            width: 100%;
            // border: 1px solid red;
            margin-top: 10px;
            font-size: 12px;
            font-family: Source Han Sans CN-Regular, Source Han Sans CN;
            font-weight: 400;
            color: #898b8d;
            line-height: 17px;
          }
        }
      }
    }
  }
}
</style>
